let ws = null;
let listeners = [];
let reconnectTimer = null;
let messageQueue = [];
let currentPresence = null;
let isManualClose = false;
let isConnecting = false;

const createConnection = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  if (!token) return;
const protocol = window.location.protocol === "https:" ? "wss" : "ws";

let baseUrl;
if (window.location.hostname === "localhost") {
    baseUrl = `localhost:8000`;
} else {
    baseUrl = window.location.host;
}

const wsUrl = `${protocol}://${baseUrl}/api/ws?access_token=${token}`;

ws = new WebSocket(wsUrl);


  ws.onopen = () => {
    console.log("🌍 WS Connected");

    isConnecting = false;

    while (messageQueue.length > 0) {
      ws.send(JSON.stringify(messageQueue.shift()));
    }

    if (currentPresence) {
      ws.send(JSON.stringify({
        type: "PRESENCE_UPDATE",
        payload: currentPresence
      }));
    }

    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
  };

  ws.onmessage = (event) => {
    try {
      const msg = JSON.parse(event.data);
      listeners.forEach(cb => cb(msg));
    } catch (e) {
      console.error("WS parse error", e);
    }
  };

  ws.onclose = (event) => {
    console.log("WS closed", event.code, event.reason);

    ws = null;
    isConnecting = false;

    if (isManualClose) {
      console.log("🛑 Manual logout — no reconnect");
      return;
    }

    console.log("🔁 Reconnecting WS...");
    reconnectTimer = setTimeout(connectSocket, 3000);
  };

  ws.onerror = (err) => console.error("WS error", err);
};

export const connectSocket = () => {
  if (ws && ws.readyState === WebSocket.OPEN) return;
  if (isConnecting) return;

  isManualClose = false;
  isConnecting = true;
  createConnection();
};

export const sendSocket = (data) => {
  if (ws?.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify(data));
  } else {
    messageQueue.push(data);
    connectSocket();
  }
};

export const subscribeSocket = (cb) => {
  if (!listeners.includes(cb)) {
    listeners.push(cb);
  }
};

export const unsubscribeSocket = (cb) => {
  listeners = listeners.filter(l => l !== cb);
};

export const setPresence = (presence) => {
  currentPresence = presence;

  if (ws?.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify({
      type: "PRESENCE_UPDATE",
      payload: currentPresence
    }));
  }
};

export const disconnectSocket = () => {
  if (!ws) return;

  isManualClose = true;

  try {
    ws.send(JSON.stringify({ type: "LOGOUT" }));
  } catch (e) {
    console.warn("WS logout send failed");
  }

  ws.close(1000, "Client logout");

  ws = null;
  listeners.length = 0;
  messageQueue.length = 0;
  currentPresence = null;

  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }

  isConnecting = false;
};
